import { FlexColumn } from "@similarweb/ui-components";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";
const { carbon, bluegrey, blue } = colorsPalettes;

export const StyledButton = styled(Button)`
    ${setFontVariant("button", carbon[0])};
    gap: 4px;
`;

export const TooltipWrapper = styled(FlexColumn)`
    gap: 16px;
`;

export const StyledTooltipHeader = styled(I18n)`
    ${setFontVariant("listItem4", bluegrey[100])};
`;
